import type { IncomingMailServerExpiryStatusGetResponse } from '@jira/router-resources__incoming-mail-server-expiry-status/src/IncomingMailServerExpiryStatusGetResponse.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type Action,
	createStore,
	createActionsHook,
	createStateHook,
	type BoundActions,
	type HookActionsFunction,
	type HookStateFunction,
} from '@atlassian/react-sweet-state';

type State = {
	isBannerShown: boolean;
	isAdmin: boolean;
	OauthTypes: IncomingMailServerExpiryStatusGetResponse['OauthTypes'];
};

export const initialState: State = {
	isBannerShown: false,
	isAdmin: false,
	OauthTypes: ['GMAIL_OAUTH'],
};

export const actions = {
	onDismiss:
		(): Action<State> =>
		({ getState, setState }) => {
			setState({
				...getState(),
				isBannerShown: false,
			});
		},
	onStateFetch:
		({
			showBanner,
			isAdmin,
			OauthTypes = ['GMAIL_OAUTH'],
		}: IncomingMailServerExpiryStatusGetResponse): Action<State> =>
		({ getState, setState }) => {
			setState({
				...getState(),
				isBannerShown: showBanner && isAdmin,
				isAdmin,
				OauthTypes,
			});
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'mail-expiry-banner',
	initialState,
	actions,
});

export const useBannerActions: HookActionsFunction<
	BoundActions<
		State,
		{
			readonly onDismiss: () => Action<State>;
			readonly onStateFetch: ({
				showBanner,
				isAdmin,
				OauthTypes,
			}: IncomingMailServerExpiryStatusGetResponse) => Action<State>;
		}
	>
> = createActionsHook(Store);
export const useBannerState: HookStateFunction<State, void> = createStateHook(Store);
